<app-page headline="SKU Mapping">
  <div center-layout>
    <div grid-layout gap="md" templateColumns="1fr 1fr" [fullWidth]="true">
      <div
        stack-layout
        borderRadius="xs"
        border="light"
        paddingHorizontal="lg"
        paddingVertical="md"
        gap="sm"
        alignItems="center"
        [minWidth]="460"
        elevation="raised"
      >
        <Text role="headline-small"> Download SKU Mapping Data </Text>

        <div center-layout [grow]="1" [fullWidth]="true">
          <div stack-layout gap="md" [fullWidth]="true">
            <div stack-layout [fullWidth]="true">
              <div box-layout paddingLeft="sm">
                <Text role="headline-small">Sales Channel</Text>
              </div>
              <div row-layout [grow]="1">
                <oui-select
                  [(value)]="downloadSalesChannelCode"
                  [options]="salesChannel.salesChannelOptions()"
                  placeholder="--select a sales channel--"
                  style="width: 100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div box-layout justifyContent="center">
          <app-download-button
            mode="text"
            [blobObservable]="
              skuMapping.downloadSkuMappingFile(downloadSalesChannelCode)
            "
            [downloadFileName]="skuMappingFileName()"
            [disable]="!downloadSalesChannelCode"
          />
        </div>
      </div>

      @if (permissionToUpload()) {
        <app-card
          headline="Upload New SKU Mapping File"
          [loading]="skuMapping.skuMappingFileUploading()"
          [loadingError]="skuMapping.skuMappingFileUploadError()"
          [loadingProgress]="skuMapping.skuMappingFileUploadProgress()"
          [loadingMessage]="
            skuMapping.skuMappingFileUploadError()
              ? 'Errors found. Processing...'
              : 'Uploading SKU Mapping File...'
          "
        >
          <div ngProjectAs="header-content">
            <oui-select
              [(value)]="uploadSalesChannelCode"
              [options]="salesChannel.salesChannelOptions()"
              placeholder="...select a sales channel"
              style="display: block; width: 280px"
            />
          </div>

          <oui-file-drop-zone
            #fileDropZone
            [height]="160"
            (fileAttached)="handleFileAttached($event)"
            (fileRemoved)="selectedFile.set(undefined)"
            [allowedFileExtensions]="['xlsx', 'xls']"
            style="width: 100%"
            [helpTemplate]="fileDropZoneContent"
          />
          <ng-template #fileDropZoneContent>
            <div stack-layout [fullWidth]="true" alignItems="center" gap="sm">
              <Text role="headline-small" align="center">
                Drag and drop the file here.
              </Text>
              <Text role="title-small" align="center">
                Only .xlsx files with headers ChannelSKUDescription,
                AssurantSKU, ChannelSKU, UPC, ItemAlias, and GTIN will be
                accepted.
              </Text>
            </div>
          </ng-template>
          <div
            row-layout
            justifyContent="space-between"
            [fullWidth]="true"
            gap="md"
          >
            <button
              text-button
              size="md"
              variant="secondary"
              (click)="fileDropZone.openFileSelector()"
            >
              Browse Files
            </button>
            <button
              text-button
              size="md"
              (click)="uploadFile()"
              [disable]="!selectedFile() || !uploadSalesChannelCode"
            >
              Upload
            </button>
          </div>
        </app-card>
      }
    </div>
  </div>
  <div box-layout paddingTop="lg" paddingVertical="md" [grow]="1">
    @if (skuMapping.noUploadHistory()) {
      <div center-layout [grow]="1" [fullWidth]="true">
        <Text role="title-large">No SKU mapping upload history.</Text>
      </div>
    }

    <app-log-table
      [datasource]="uploadHistoryDatasource"
      label="SKU Mapping Upload History"
      [loading]="skuMapping.uploadHistory.isLoading()"
      (reload)="skuMapping.uploadHistory.reload()"
    />
  </div>
</app-page>

